import * as Types from '../../lib/types';

export const TextBlockData_1: Types.TextBlock = {
  _type: 'textBlock',
  _key: 'textBlock_1',
  isDarkMode: true,
  title:
    'Light Phones are simple devices with quality tools, designed to be used as little as possible.',
  backgroundMedia: {
    desktop: {
      _type: 'video',
      url: 'https://assets.thelightphone.com/videos/Both_Phones.v3.mp4',
      alt: 'Video showing how the Light Phone III and Light Phone II let you live your best life.',
      posterImage: {
        _type: 'image',
        url: 'https://assets.thelightphone.com/images/both-phones-posterimage.png',
        alt: 'Person taking a picture with the Light Phone III.'
      }
    }
  },
  showBorderTop: false
};

export const TextBlockData_2: Types.TextBlock = {
  _type: 'textBlock',
  _key: 'textBlock_2',
  isDarkMode: true,
  title:
    'The value of the Light Phone is not necessarily in any specific feature, but rather the experience we call going light. In our hyper-connected lives, going light is a profound shift.',
  backgroundMedia: {
    desktop: {
      _type: 'video',
      url: '//assets.thelightphone.com/videos/GoingLight.v2.mp4',
      alt: 'Video of the Light Phone OS',
      posterImage: {
        _type: 'image',
        url: '//assets.thelightphone.com/images/Screenshot_2025-01-13_at_11.48.09_AM.png',
        alt: 'Light Phone OS'
      }
    }
  },
  foregroundMedia: {
    _type: 'foregroundMedia',
    media: {
      _type: 'image',
      url: 'https://assets.thelightphone.com/images/InterfaceOverlay_0115.png',
      alt: 'Light Phone OS'
    },
    video: {
      _type: 'video',
      url: 'https://vimeo.com/954143759',
      alt: 'Video of the Light Phone OS',
      posterImage: {
        _type: 'image',
        url: '//assets.thelightphone.com/images/Screenshot_2025-01-13_at_11.50.05_AM.png',
        alt: 'Light Phone OS'
      },
      caption: 'What is a Light Phone?'
    }
  },
  showBorderTop: false
};

export const TextBlockData_3: Types.TextBlock = {
  _type: 'textBlock',
  _key: 'textBlock_3',
  isDarkMode: true,
  title:
    'Light is an alternative to the tech monopolies that are fighting aggressively for our time & attention. We make tools that serve you, not the other way around.',
  backgroundMedia: {
    desktop: {
      _type: 'accessibleImage',
      _key: 'textBlock_3_backgroundMedia',
      asset: {
        _id: '6hkHam9NcY3rkdMr96JNRP',
        url: '//assets.thelightphone.com/images/stars.png',
        metadata: {
          lqip: '',
          dimensions: {
            aspectRatio: 1,
            width: 1000,
            height: 1000
          }
        }
      },
      alt: 'Illustration of stars'
    }
  },
  foregroundMedia: {
    _type: 'foregroundMedia',
    media: {
      _type: 'video',
      url: '//assets.thelightphone.com/videos/scrolling-smooth.mp4',
      alt: 'Looping video illustration of an eye with the reflection of someone scrolling on a phone',
      applyScreenBlend: true,
      posterImage: {
        _type: 'image',
        url: '//assets.thelightphone.com/images/Screenshot_2025-01-13_at_11.51.56_AM.png',
        alt: 'Illustration of an eye'
      }
    },
    video: {
      _type: 'video',
      url: 'https://vimeo.com/1028897635',
      alt: 'Video about the addictive nature of smartphones',
      posterImage: {
        _type: 'image',
        url: '//assets.thelightphone.com/images/Screenshot_2025-01-13_at_11.51.56_AM.png',
        alt: 'Illustration of an eye'
      },
      caption: 'A radically different phone'
    }
  },
  showBorderTop: false
};

export const TextBlockData_4: Types.TextBlock = {
  _type: 'textBlock',
  _key: 'textBlock_4',
  isDarkMode: false,
  title: 'Thinking about getting a Light Phone?',
  foregroundMedia: {
    _type: 'foregroundMedia',
    media: {
      _type: 'image',
      url: 'https://assets.thelightphone.com/images/light-phone-users-0115.jpg',
      alt: 'Composite image of light phone users.'
    },
    video: {
      _type: 'video',
      url: 'https://vimeo.com/1020289535',
      alt: 'Video testimonials of real Light Phone users',
      posterImage: {
        _type: 'image',
        url: 'https://assets.thelightphone.com/images/light-phone-users-0115.jpg',
        alt: 'Composite image of light phone users.'
      },
      caption: 'Hear from everyday Light Phone users'
    }
  },
  showBorderTop: true
};

export const TextBlockData_5: Types.TextBlock = {
  _type: 'textBlock',
  _key: 'textBlock_5',
  isDarkMode: false,
  title:
    'Over 10 years, more than 100,000 people have gone light. It’s a small but mighty movement, and it’s only grown stronger.',
  foregroundMedia: {
    _type: 'foregroundMedia',
    media: {
      _type: 'image',
      url: '//assets.thelightphone.com/images/kai_joe.png',
      alt: 'Kai and Joe in the Light Phone factory.'
    },
    video: {
      _type: 'video',
      url: 'https://vimeo.com/1014506785',
      alt: 'Video of Kai and Joe in the Light Phone factory.',
      posterImage: {
        _type: 'image',
        url: '//assets.thelightphone.com/images/kai_joe.png',
        alt: 'Kai and Joe in the Light Phone factory.'
      },
      caption: 'The little phone company'
    }
  },
  showBorderTop: true
};
